module.exports = __webpack_public_path__ + "img/no-people.3cd1f7ec.png";